export const sortUniversal = (array, sort_key) => {
  return array.sort((a, b) => {
    if (!isNaN(parseInt(a[sort_key])) && !isNaN(parseInt(b[sort_key]))) {
      if (parseInt(a[sort_key]) > parseInt(b[sort_key])) {
        return 1
      } else if (parseInt(a[sort_key]) < parseInt(b[sort_key])) {
        return -1
      } else {
        return 0
      }
    } else {
      if (a[sort_key] != null && b[sort_key] != null) {
        if (a[sort_key].toUpperCase() > b[sort_key].toUpperCase()) {
          return 1
        } else if (a[sort_key].toUpperCase() < b[sort_key].toUpperCase()) {
          return -1
        } else {
          return 0
        }
      }
    }
  })
}